import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { selectMyConnectionsFeatureFlag } from '../../user/selectors';
import { Footer } from '../footer/Footer';
import { Header } from '../header/Header';

export const Layout = (props: PropsWithChildren) => {
    const isConnections = useSelector(selectMyConnectionsFeatureFlag);

    return (
        <div
            className={`min-h-screen relative ${isConnections ? 'bg-green-200' : 'bg-green-100'} grid`}
            style={{ gridTemplateRows: 'auto 1fr auto', gridTemplateColumns: '100%' }}
        >
            <div className="fixed top-[-154vw] left-[-120%] w-[200vw] h-[200vw] bg-[#92CBBD] rounded-full" />
            <Header />
            <main className="relative">{props.children}</main>
            <Footer />
        </div>
    );
};
